<h1 mat-dialog-title>Welcome {{ name }}</h1>
<div mat-dialog-content>
  <p>
    <strong>
      Your library card {{ expireText }} on <span class="red">{{ expireDate }}</span
      >. Please contact the library for assistance
    </strong>
  </p>
</div>

<mat-dialog-actions align="end">
  <button class="btn btn-primary" mat-dialog-close tabindex="-1" type="button">Close</button>
</mat-dialog-actions>
